import { Typography } from 'components/Contentful'
import { dollarUSLocale } from './utils'

function TitleAndSubtitle({ finalTitle, finalSubTitle, sliderAmountConfig, color = true }) {
  return (
    <>
      {finalTitle && (
        <Typography
          content={finalTitle + ` $${dollarUSLocale.format(sliderAmountConfig.max)}`}
          variant="displayLg"
          mobileVariant="bodyLg"
          responsive={true}
          data-testid="heloc-title"
          className="pb-5 lg:pr-4 lg:pl-4 pr-4 pl-4 font-bold!"
          fontWeight="bold"
          color={color ? 'black' : 'white'}
        />
      )}
      {finalSubTitle && (
        <div className="flex flex-col items-center">
          <Typography
            content={finalSubTitle}
            color={color ? 'black' : 'white'}
            variant="bodyLg"
            mobileVariant="bodySm"
            responsive={true}
            data-testid="heloc-sub-title"
            className="pb-5 pr-4 pl-4"
          />
        </div>
      )}
    </>
  )
}

export { TitleAndSubtitle }
